import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Github, Heart, Eye } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [visits, setVisits] = useState(null);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Registrar visita y obtener stats
    const trackAndFetch = async () => {
      try {
        // Registrar visita (solo una vez por sesión)
        const visited = sessionStorage.getItem('blox_visited');
        if (!visited) {
          await fetch(`${API_URL}/api/stats/visit`, { method: 'POST' });
          sessionStorage.setItem('blox_visited', 'true');
        }
        
        // Obtener estadísticas
        const response = await fetch(`${API_URL}/api/stats`);
        const data = await response.json();
        setVisits(data.visits);
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };

    trackAndFetch();
  }, [API_URL]);

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center mb-4 group">
              <img 
                src="/blox-logo.png" 
                alt="BLOX" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Lenguaje de scripting embebible con API C. BLOX Core dentro de tus aplicaciones nativas.
            </p>
          </div>

          {/* Recursos */}
          <div>
            <h3 className="text-white font-semibold mb-4">Producto</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/embedded-scripting-language" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  BLOX Core (embebible)
                </Link>
              </li>
              <li>
                <Link to="/cli" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm" data-testid="footer-cli-link">
                  BLOX CLI (terminal)
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  Documentación
                </Link>
              </li>
              <li>
                <Link to="/download" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  Descargas
                </Link>
              </li>
            </ul>
          </div>

          {/* Comunidad */}
          <div>
            <h3 className="text-white font-semibold mb-4">Comunidad</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm flex items-center gap-2">
                  <Github className="w-4 h-4" />
                  GitHub
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="/legal/terms" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  Términos de Uso
                </a>
              </li>
              <li>
                <a href="/legal/privacy" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="/legal/license" className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                  Licencia
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm mb-4 md:mb-0 flex items-center">
            © {currentYear} Blox. Hecho con <Heart className="w-4 h-4 mx-1 text-red-500 fill-current" /> para desarrolladores.
          </p>
          
          <div className="flex items-center space-x-6">
            {/* Contador de visitas */}
            {visits !== null && (
              <div className="flex items-center gap-1.5 text-slate-500 text-sm">
                <Eye className="w-4 h-4" />
                <span>{visits.toLocaleString('es-PY')} visitas</span>
              </div>
            )}
            
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyan-400 transition-colors">
              <Github className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
